import { createI18n } from 'vue-i18n'
import { adminLocales, readAdminLocale } from '@/apps/admin/i18n/locale'
import { portalMessages } from '@/apps/portal/i18n/messages'
import { PORTAL_LOCALES, readPortalLocale, writePortalLocale } from '@/apps/portal/i18n/locale'
import { getSiteTitle, getSiteSubtitle } from '@/stores/portal/agentStore'

const adminEntry = window.location.pathname.startsWith('/admin')
const initialLocale = adminEntry ? readAdminLocale() : readPortalLocale()

if (!adminEntry) {
  writePortalLocale(initialLocale)
}

const messages = { ...portalMessages }

for (const locale of adminLocales) {
  messages[locale.code] = {
    ...(messages[locale.code] || {}),
    admin: locale.messages
  }
}

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: {
    'zh-TW': ['zh-CN'],
    'en-US': ['zh-CN'],
    default: ['zh']
  },
  messages
})

// Portal 站点名称来自运行时配置；Admin 语言资源不参与此更新。
export function updatePlatformInfo() {
  const title = getSiteTitle()
  const subtitle = getSiteSubtitle()

  for (const locale of PORTAL_LOCALES) {
    const localeMessages = i18n.global.messages.value[locale] || {}
    if (!localeMessages.platform) continue

    i18n.global.mergeLocaleMessage(locale, {
      platform: {
        ...localeMessages.platform,
        title,
        subtitle
      }
    })
  }
}

export default i18n
